module.exports = __webpack_public_path__ + "static/media/24.9e899df1.jpeg";